import React from 'react';

// ─── Base Props ──────────────────────────────────────────────────────
interface IconProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
    size?: number;
}

const defaultProps = (props: IconProps, viewBox = '0 0 24 24') => ({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox,
    fill: 'currentColor',
    width: props.size || '1em',
    height: props.size || '1em',
    ...props,
    className: props.className || '',
});

// ═══════════════════════════════════════════════════════════════════════
//  SOLID ICONS
// ═══════════════════════════════════════════════════════════════════════

export const GemIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5L210.5 179.8 63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8l-147.2-12.3 57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z" />
    </svg>
);

export const FilmIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M0 96C0 60.7 28.7 32 64 32h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 0v32h32V96H96zm320 0v32h32V96h-32zM96 192v32h32v-32H96zm320 0v32h32v-32h-32zM96 288v32h32v-32H96zm320 0v32h32v-32h-32zM96 384v32h32v-32H96zm320 0v32h32v-32h-32z" />
    </svg>
);

export const ServerIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0z" />
    </svg>
);

export const FilterIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M3.9 54.9C10.5 40.9 24.5 32 40 32h432c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3L224 440c-8.5-6.5-13.3-16.7-13.3-27.5V320.9L18.6 97.4C8.8 85.4 5.1 68.9 3.9 54.9z" />
    </svg>
);

export const TvIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 640 512')}>
        <path d="M64 64V352h512V64H64zM0 64C0 28.7 28.7 0 64 0h512c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z" />
    </svg>
);

export const LanguageIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 576 512')}>
        <path d="M160 0c17.7 0 32 14.3 32 32l0 32 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-9.6 0-8.4 23.1c-16.4 45.2-41.1 86.5-72.2 122 14.2 8.8 29 16.6 44.4 23.5l50.4 22.4 62.2-140c5.1-11.6 16.6-19 29.2-19s24.1 7.4 29.2 19l128 288c7.2 16.2-.1 35.1-16.2 42.2s-35.1-.1-42.2-16.2l-20-45-157.5 0-20 45c-7.2 16.2-26.1 23.4-42.2 16.2s-23.4-26.1-16.2-42.2l39.8-89.5-50.4-22.4c-23-10.2-45-22.4-65.8-36.4-21.3 17.2-44.6 32.2-69.5 44.7L78.3 380.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l34.5-17.3c16.3-8.2 31.8-17.7 46.4-28.3-13.8-12.7-26.8-26.4-38.9-40.9L81.6 224.7c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l10.2 12.2c11.5 13.9 24.1 26.8 37.4 38.7 27.5-30.4 49.2-66.1 63.5-105.4l.5-1.2-210.3 0C14.3 128 0 113.7 0 96S14.3 64 32 64l96 0 0-32c0-17.7 14.3-32 32-32zM416 270.8L365.7 384 466.3 384 416 270.8z" />
    </svg>
);

export const VideoIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 576 512')}>
        <path d="M0 128C0 92.7 28.7 64 64 64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm559.7-4.2l-128 64C422.2 192.5 416 201.6 416 211.7V300.3c0 10.1 6.2 19.2 15.7 22.9l128 64c19.7 9.8 42.3-4.7 42.3-22.9V146.7c0-18.2-22.6-32.7-42.3-22.9z" />
    </svg>
);

export const SlidersIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z" />
    </svg>
);

export const CopyIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 448 512')}>
        <path d="M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
    </svg>
);

export const EllipsisIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 448 512')}>
        <path d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
    </svg>
);

export const ShareNodesIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 448 512')}>
        <path d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z" />
    </svg>
);

export const RocketIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7.7-21.5 13.5-35.8H48c-26.5 0-48-21.5-48-48c0-18.8 10.9-35.1 26.7-42.9L192 116.9V96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v20.9l165.3 78.2C501.1 202.9 512 219.2 512 238c0 26.5-21.5 48-48 48H380.5c5.8 14.3 10.5 26.9 13.5 35.8c3.8 11.4 .7 23.7-7.7 32.2l-30.9 30.9C340.7 399.5 320.8 416 304 448c-6 11.5-17.7 24-32 24s-26-12.5-32-24c-16.8-32-36.7-48.5-51.4-63.1l-32-32zM272 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z" />
    </svg>
);

export const WifiIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 640 512')}>
        <path d="M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-1 12.2-12.8 11.8-33-1-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 168.8-3.3 189 8.9 201.2c12.2 12.8 32.4 13.2 45.2 1zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8c11.7-13.3 10.4-33.5-2.8-45.2C462.2 222.5 393.6 192 320 192s-142.2 30.5-190.6 72c-13.3 11.7-14.5 31.9-2.8 45.2c11.7 13.3 31.9 14.5 45.2 2.8C211.4 277.1 263.2 256 320 256zm0 128a64 64 0 1 0 0 128 64 64 0 1 0 0-128z" />
    </svg>
);

export const TriangleExclamationIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.5-7.7-34.6-20.2s-7-27.7 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z" />
    </svg>
);

export const LightbulbIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 384 512')}>
        <path d="M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80H112c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z" />
    </svg>
);

export const DesktopIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 576 512')}>
        <path d="M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64v288H64V64h448z" />
    </svg>
);

export const CogIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
    </svg>
);

export const SunIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 24 24')} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
);

export const MoonIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 384 512')}>
        <path d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z" />
    </svg>
);

export const UserSecretIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 448 512')}>
        <path d="M224 16c-6.7 0-10.8-2.8-15.5-6.1C204.3 6.8 198.2 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H88c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8.2c-4.2 24.3 .4 47.8 12.6 67.3L37.4 400.2c-9.7 5.2-15.4 15.4-15.4 26.3V464c0 26.5 21.5 48 48 48h308c26.5 0 48-21.5 48-48v-37.5c0-10.9-5.7-21.1-15.4-26.3l-71.4-44.6c12.2-19.5 16.8-43 12.6-67.3H360c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C390.9 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-22.2 0-28.3 6.8-32.5 9.9C234.8 13.2 230.7 16 224 16zm-37.4 248H261.4L288 464H160l-26.6-200h53.2z" />
    </svg>
);

export const DownloadIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
    </svg>
);

export const TimesIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 384 512')}>
        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
    </svg>
);

export const EnvelopeIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
    </svg>
);

export const InfoCircleIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
    </svg>
);

export const MagnifyingGlassIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
    </svg>
);

export const ArrowUpIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 384 512')}>
        <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l137.4 137.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" />
    </svg>
);


export const ChevronUpIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path stroke="currentColor" strokeWidth="32" strokeLinecap="round" strokeLinejoin="round" d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
    </svg>
);

export const CloudArrowDownIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 24 24')} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 13v8M12 21l-3-3M12 21l3-3" />
        <path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29" />
    </svg>
);

export const WifiSlashIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 640 512')}>
        {/* Wifi signal arcs + center dot (same geometry as WifiIcon) */}
        <path d="M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-1 12.2-12.8 11.8-33-1-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 168.8-3.3 189 8.9 201.2c12.2 12.8 32.4 13.2 45.2 1zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8c11.7-13.3 10.4-33.5-2.8-45.2C462.2 222.5 393.6 192 320 192s-142.2 30.5-190.6 72c-13.3 11.7-14.5 31.9-2.8 45.2c11.7 13.3 31.9 14.5 45.2 2.8C211.4 277.1 263.2 256 320 256zm0 128a64 64 0 1 0 0 128 64 64 0 1 0 0-128z" />
        {/* Diagonal slash bar */}
        <rect x="296" y="-44" width="48" height="600" rx="24" transform="rotate(39 320 256)" />
    </svg>
);

export const RotateRightIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z" />
    </svg>
);

export const HouseIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 576 512')}>
        <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V416 352c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40v-72.5c0-4.1 .4-8 1.1-11.9V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
    </svg>
);

export const CircleExclamationIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0z" />
    </svg>
);

export const FileContractIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 384 512')}>
        <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 5.3-16 .5-14.2-7.4l9.6-40.4L99.1 314c-7-6.1-3.8-17.7 5-18.3L140 293l17.3-37.1c3.1-6.7 12.6-7.1 16.2-.7l20.6 36.7 35.8 2.5c8.8.6 11.9 11.7 5.1 17.7L205.6 338l10.3 40.5c2 7.8-7.8 13-14 7.6l-31.3-27.2-36.4 5z" />
    </svg>
);

export const CommentsIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 576 512')}>
        <path d="M384 144c0 97.2-86 176-192 176-26.7 0-52.1-5-75.2-14L35.2 349.2c-9.3 4.9-20.7 3.2-28.2-4.2s-9.2-18.9-4.2-28.2l35.6-67.2C14.3 220.2 0 183.6 0 144 0 46.8 86-32 192-32S384 46.8 384 144zm0 368c-94.1 0-172.4-62.1-188.8-144 120-1.5 224.3-86.9 235.8-202.7 83.3 19.2 145 88.3 145 170.7 0 39.6-14.3 76.2-38.4 105.6l35.6 67.2c4.9 9.3 3.2 20.7-4.2 28.2s-18.9 9.2-28.2 4.2L459.2 498c-23.1 9-48.5 14-75.2 14z" />
    </svg>
);

export const CommentSmsIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M256 480c141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240c0 54.3 19.2 104.3 51.6 144.5L2.8 476.8c-4.8 9-3.3 20 3.6 27.5s17.8 9.8 27.1 5.8l118.4-50.7C183.7 472.6 218.9 480 256 480zM140.8 172.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6c23 0 41.6 18.6 41.6 41.6s-18.6 41.6-41.6 41.6l-25.6 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l25.6 0c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6zm188.8 41.6c0-23 18.6-41.6 41.6-41.6l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6c23 0 41.6 18.6 41.6 41.6s-18.6 41.6-41.6 41.6l-25.6 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l25.6 0c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6c-23 0-41.6-18.6-41.6-41.6zm-98.3-33.8l24.7 41.1 24.7-41.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 102.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-44.6-8.7 14.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8l-8.7-14.5 0 44.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-102.4c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2z" />
    </svg>
);

export const ClapperboardIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        {/* Parallelogram overlays BEHIND the main path — only visible through cutout holes */}
        <polygon points="134.1,64 38.1,160 106,160 202,64" fill="#000000" className="clapper-slash clapper-slash-3" />
        <polygon points="294.1,64 198.1,160 266,160 362,64" fill="#000000" className="clapper-slash clapper-slash-2" />
        <polygon points="454,64 358,160 426,160 498,88" fill="#000000" className="clapper-slash clapper-slash-1" />
        {/* Main icon body — painted on top, hides overlay everywhere except cutout holes */}
        <path d="M448 64c2 0 3.9 .1 5.8 .3l-95.7 95.7 67.9 0 72-72c8.8 11 14 24.9 14 40l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l70.1 0-96 96 67.9 0 95-95 1-1 92.1 0-96 96 67.9 0 95-95 1-1 86.1 0z" />
    </svg>
);

export const HeartIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c56.8-53 56.8-139.3 0-192.3s-149-53-205.7 0L256 110.7l-2.7-2.6c-56.7-53-149-53-205.7 0s-56.8 139.3 0 192.3z" />
    </svg>
);

export const ArrowRightIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 24 24')} fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
    </svg>
);

export const PlusIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 24 24')} fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
    </svg>
);

export const CheckIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 24 24')} fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

// ═══════════════════════════════════════════════════════════════════════
//  BRAND ICONS
// ═══════════════════════════════════════════════════════════════════════

export const FacebookIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 320 512')}>
        <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V136.9c0-51.7 20.3-71.5 72.7-71.5c16.8 0 29.4 .5 44.3 3.1V2.2C296.6.7 273.6 0 248 0 146.1 0 96 56.1 96 154.5V201.5H0v97.8H80z" />
    </svg>
);

export const WhatsAppIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 448 512')}>
        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
    </svg>
);

export const TelegramIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 496 512')}>
        <path d="M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM363 176.7c-3.7 39.2-19.9 134.4-28.1 178.3-3.5 18.6-10.3 24.8-16.9 25.4-14.4 1.3-25.3-9.5-39.3-18.7-21.8-14.3-34.2-23.2-55.3-37.2-24.5-16.1-8.6-25 5.3-39.5 3.7-3.8 67.1-61.5 68.3-66.7 .2-.7 .3-3.1-1.2-4.4s-3.6-.8-5.1-.5q-3.3.7-104.6 69.1-14.8 10.2-26.9 9.9c-8.9-.2-25.9-5-38.6-9.1-15.5-5-27.9-7.7-26.8-16.3q.8-6.7 18.5-13.7 108.4-47.2 144.6-62.3c68.9-28.6 83.2-33.6 92.5-33.8 2.1 0 6.6.5 9.6 2.9a10.5 10.5 0 0 1 3.5 6.7A43.8 43.8 0 0 1 363 176.7z" />
    </svg>
);

export const XTwitterIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
    </svg>
);

export const PinterestIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M504 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3 .8-3.4 5-20.3 6.9-28.1 .6-2.5 .3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2C161.5 437.2 163.5 467.4 165.6 487 73.4 450.9 8 361.1 8 256 8 119 119 8 256 8S504 119 504 256z" />
    </svg>
);

export const ThreadsIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 448 512')}>
        <path d="M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8 29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2-36.2 36.2-80.3 52.5-142.6 53l-.3 0c-70.2-.5-124.1-24.1-160.4-70.2-32.3-41-48.9-98.1-49.5-169.6l0-.5C17 184.3 33.6 127.2 65.9 86.2 102.2 40.1 156.2 16.5 226.4 16l.3 0c70.3 .5 124.9 24 162.3 69.9 18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4-29.2-35.8-73-54.2-130.5-54.6-57 .5-100.1 18.8-128.2 54.4-26.2 33.3-39.8 81.5-40.3 143.2 .5 61.7 14.1 109.9 40.3 143.3 28 35.6 71.2 53.9 128.2 54.4 51.4-.4 85.4-12.6 113.7-40.9 32.3-32.2 31.7-71.8 21.4-95.9-6.1-14.2-17.1-26-31.9-34.9-3.7 26.9-11.8 48.3-24.7 64.8-17.1 21.8-41.4 33.6-72.7 35.3-23.6 1.3-46.3-4.4-63.9-16-20.8-13.8-33-34.8-34.3-59.3-2.5-48.3 35.7-83 95.2-86.4 21.1-1.2 40.9-.3 59.2 2.8-2.4-14.8-7.3-26.6-14.6-35.2-10-11.7-25.6-17.7-46.2-17.8l-.7 0c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1l.8 0c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2 .1 0zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3 25.6-1.4 54.6-11.4 59.5-73.2-13.2-2.9-27.8-4.4-43.4-4.4-4.8 0-9.6 .1-14.4 .4-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z" />
    </svg>
);

export const LinkedInIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 448 512')}>
        <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.83-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
    </svg>
);

export const MessengerIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M256.6 8c-140 0-248.6 102.3-248.6 240.6 0 72.3 29.7 134.8 78.1 177.9 8.3 7.5 6.6 11.9 8 58.2 .1 3.2 1 6.4 2.6 9.2s3.9 5.2 6.7 6.9 5.9 2.8 9.1 3 6.5-.3 9.5-1.6C174.9 479 175.6 477.2 184.6 479.6 337.8 521.8 504 423.7 504 248.6 504 110.3 396.6 8 256.6 8zM405.8 193.1l-73 115.6c-2.8 4.3-6.4 8.1-10.6 11s-9.1 4.8-14.1 5.8-10.3 .8-15.3-.4-9.7-3.4-13.8-6.4l-58.1-43.5c-2.6-1.9-5.8-3-9-3s-6.4 1.1-9 3l-78.4 59.4c-10.5 7.9-24.2-4.6-17.1-15.7l73-115.6c2.8-4.3 6.4-8.1 10.6-11s9.1-4.8 14.1-5.8 10.3-.8 15.3 .4 9.7 3.4 13.9 6.4l58.1 43.5c2.6 1.9 5.8 3 9 3s6.4-1.1 9-3l78.4-59.4c10.4-8 24.1 4.5 17.1 15.6z" />
    </svg>
);

export const RedditIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M373 138.6c-25.2 0-46.3-17.5-51.9-41l0 0c-30.6 4.3-54.2 30.7-54.2 62.4l0 .2c47.4 1.8 90.6 15.1 124.9 36.3c12.6-9.7 28.4-15.5 45.5-15.5c41.3 0 74.7 33.4 74.7 74.7c0 29.8-17.4 55.5-42.7 67.5c-2.4 86.7-97 156.4-214.4 156.4S41.2 410.2 38.8 323.5C13.5 311.5-3.9 285.8-3.9 256c0-41.3 33.4-74.7 74.7-74.7c17.2 0 33 5.8 45.5 15.5C150.8 175.3 194 162 241.4 160.2l0-.2c0-45.2 32.6-82.8 75.6-90.4c6.9-29.1 33.2-50.8 64.3-50.8c36.4 0 66 29.6 66 66s-29.6 65.8-66 65.8l-8.3-2zm-224.9 120c-25.6 0-46.3 20.7-46.3 46.3s20.7 46.3 46.3 46.3 46.3-20.7 46.3-46.3-20.7-46.3-46.3-46.3zm214.4 0c-25.6 0-46.3 20.7-46.3 46.3s20.7 46.3 46.3 46.3 46.3-20.7 46.3-46.3-20.7-46.3-46.3-46.3zm-125.4 128c-15.2 0-27.7 7.4-33.3 18.8-4.5 9.2 1.7 20 12.2 20h42.2c10.5 0 16.8-10.8 12.2-20-5.6-11.4-18.1-18.8-33.3-18.8z" />
    </svg>
);

export const AndroidIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 576 512')}>
        <path d="M420.55 301.93a24 24 0 1 1 24-24 24 24 0 0 1-24 24m-265.1 0a24 24 0 1 1 24-24 24 24 0 0 1-24 24m273.7-144.48l47.94-83a10 10 0 1 0-17.27-10l-48.54 84.07a301.25 301.25 0 0 0-246.56 0L116.18 64.45a10 10 0 1 0-17.27 10l47.94 83C64.53 202.22 8.24 285.55 0 384h576c-8.24-98.45-64.54-181.78-146.85-226.55" />
    </svg>
);

export const AppleIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 384 512')}>
        <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
    </svg>
);

export const DiscordIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 576 512')}>
        <path d="M492.5 69.8c-.2-.3-.4-.6-.8-.7-38.1-17.5-78.4-30-119.7-37.1-.4-.1-.8 0-1.1 .1s-.6 .4-.8 .8c-5.5 9.9-10.5 20.2-14.9 30.6-44.6-6.8-89.9-6.8-134.4 0-4.5-10.5-9.5-20.7-15.1-30.6-.2-.3-.5-.6-.8-.8s-.7-.2-1.1-.2c-41.3 7.1-81.6 19.6-119.7 37.1-.3 .1-.6 .4-.8 .7-76.2 113.8-97.1 224.9-86.9 334.5 0 .3 .1 .5 .2 .8s.3 .4 .5 .6c44.4 32.9 94 58 146.8 74.2 .4 .1 .8 .1 1.1 0s.7-.4 .9-.7c11.3-15.4 21.4-31.8 30-48.8 .1-.2 .2-.5 .2-.8s0-.5-.1-.8-.2-.5-.4-.6-.4-.3-.7-.4c-15.8-6.1-31.2-13.4-45.9-21.9-.3-.2-.5-.4-.7-.6s-.3-.6-.3-.9 0-.6 .2-.9 .3-.5 .6-.7c3.1-2.3 6.2-4.7 9.1-7.1 .3-.2 .6-.4 .9-.4s.7 0 1 .1c96.2 43.9 200.4 43.9 295.5 0 .3-.1 .7-.2 1-.2s.7 .2 .9 .4c2.9 2.4 6 4.9 9.1 7.2 .2 .2 .4 .4 .6 .7s.2 .6 .2 .9-.1 .6-.3 .9-.4 .5-.6 .6c-14.7 8.6-30 15.9-45.9 21.8-.2 .1-.5 .2-.7 .4s-.3 .4-.4 .7-.1 .5-.1 .8 .1 .5 .2 .8c8.8 17 18.8 33.3 30 48.8 .2 .3 .6 .6 .9 .7s.8 .1 1.1 0c52.9-16.2 102.6-41.3 147.1-74.2 .2-.2 .4-.4 .5-.6s.2-.5 .2-.8c12.3-126.8-20.5-236.9-86.9-334.5zm-302 267.7c-29 0-52.8-26.6-52.8-59.2s23.4-59.2 52.8-59.2c29.7 0 53.3 26.8 52.8 59.2 0 32.7-23.4 59.2-52.8 59.2zm195.4 0c-29 0-52.8-26.6-52.8-59.2s23.4-59.2 52.8-59.2c29.7 0 53.3 26.8 52.8 59.2 0 32.7-23.2 59.2-52.8 59.2z" />
    </svg>
);

export const SnapchatIcon: React.FC<IconProps> = (props) => (
    <svg {...defaultProps(props, '0 0 512 512')}>
        <path d="M497.1 366.6c-3.4-9.2-9.8-14.1-17.1-18.2-1.4-.8-2.6-1.5-3.7-1.9-2.2-1.1-4.4-2.2-6.6-3.4-22.8-12.1-40.6-27.3-53-45.4-3.5-5.1-6.6-10.5-9.1-16.1-1.1-3-1-4.7-.2-6.3 .8-1.2 1.7-2.2 2.9-3 3.9-2.6 8-5.2 10.7-7 4.9-3.2 8.8-5.7 11.2-7.4 9.4-6.5 15.9-13.5 20-21.3 2.9-5.4 4.5-11.3 4.9-17.4s-.6-12.2-2.8-17.8c-6.2-16.3-21.6-26.4-40.3-26.4-3.9 0-7.9 .4-11.7 1.2-1 .2-2.1 .5-3.1 .7 .2-11.2-.1-22.9-1.1-34.5-3.5-40.8-17.8-62.1-32.7-79.2-9.5-10.7-20.7-19.7-33.2-26.7-22.6-12.9-48.2-19.4-76.1-19.4s-53.4 6.5-76 19.4c-12.5 7-23.7 16.1-33.3 26.8-14.9 17-29.2 38.4-32.7 79.2-1 11.6-1.2 23.4-1.1 34.5-1-.3-2-.5-3.1-.7-3.9-.8-7.8-1.2-11.7-1.2-18.7 0-34.1 10.1-40.3 26.4-2.2 5.7-3.2 11.8-2.8 17.8s2 12 4.9 17.4c4.1 7.8 10.7 14.7 20 21.3 2.5 1.7 6.4 4.2 11.2 7.4 2.6 1.7 6.5 4.2 10.3 6.7 1.3 .9 2.4 2 3.3 3.3 .8 1.6 .8 3.4-.4 6.6-2.5 5.5-5.5 10.8-8.9 15.8-12.1 17.7-29.4 32.6-51.4 44.6-11.7 6.2-23.9 10.3-29 24.3-3.9 10.5-1.3 22.5 8.5 32.6 3.6 3.8 7.8 6.9 12.4 9.4 9.6 5.3 19.8 9.3 30.3 12.1 2.2 .6 4.3 1.5 6.1 2.7 3.6 3.1 3.1 7.9 7.8 14.8 2.4 3.6 5.4 6.7 9 9.1 10 6.9 21.3 7.4 33.2 7.8 10.8 .4 23 .9 36.9 5.5 5.8 1.9 11.8 5.6 18.7 9.9 16.7 10.3 39.6 24.3 77.8 24.3s61.3-14.1 78.1-24.4c6.9-4.2 12.9-7.9 18.5-9.8 13.9-4.6 26.2-5.1 36.9-5.5 11.9-.5 23.2-.9 33.2-7.8 4.2-2.9 7.7-6.7 10.2-11.2 3.4-5.8 3.4-9.9 6.6-12.8 1.8-1.2 3.7-2.1 5.8-2.6 10.7-2.8 21-6.9 30.8-12.2 4.9-2.6 9.3-6.1 13-10.2l.1-.2c9.2-9.9 11.5-21.5 7.8-31.8zm-34 18.3c-20.7 11.5-34.5 10.2-45.3 17.1-9.1 5.9-3.7 18.5-10.3 23.1-8.1 5.6-32.2-.4-63.2 9.9-25.6 8.5-42 32.8-88 32.8s-62-24.3-88.1-32.9c-31-10.3-55.1-4.2-63.2-9.9-6.6-4.6-1.2-17.2-10.3-23.1-10.7-6.9-24.5-5.7-45.3-17.1-13.2-7.3-5.7-11.8-1.3-13.9 75.1-36.4 87.1-92.6 87.7-96.7 .6-5 1.4-9-4.2-14.1-5.4-5-29.2-19.7-35.8-24.3-10.9-7.6-15.7-15.3-12.2-24.6 2.5-6.5 8.5-8.9 14.9-8.9 2 0 4 .2 6 .7 12 2.6 23.7 8.6 30.4 10.2 .8 .2 1.6 .3 2.5 .3 3.6 0 4.9-1.8 4.6-5.9-.8-13.1-2.6-38.7-.6-62.6 2.8-32.9 13.4-49.2 26-63.6 6.1-6.9 34.5-37 88.9-37S339 74.2 345 81.1c12.6 14.4 23.2 30.7 26 63.6 2.1 23.9 .3 49.5-.6 62.6-.3 4.3 1 5.9 4.6 5.9 .8 0 1.7-.1 2.5-.3 6.7-1.6 18.4-7.6 30.4-10.2 2-.4 4-.7 6-.7 6.4 0 12.4 2.5 14.9 8.9 3.5 9.4-1.2 17-12.2 24.6-6.6 4.6-30.4 19.3-35.8 24.3-5.6 5.1-4.8 9.1-4.2 14.2 .5 4.2 12.5 60.4 87.7 96.7 4.4 2.2 11.9 6.7-1.3 14.1z" />
    </svg>
);

export const AnimatedClapperboard: React.FC<IconProps> = (props) => (
    <svg
        {...defaultProps(props, '0 0 100 100')}
        fill="none"
    >
        {/* Clapperboard base (bottom part) */}
        <path
            d="M10 38 H90 V85 C90 87.8 87.8 90 85 90 H15 C12.2 90 10 87.8 10 85 Z"
            fill="var(--clapper-base)"
            stroke="var(--clapper-border)"
            strokeWidth="1.5"
        />
        {/* White stripes decoration on clapperboard base */}
        <path
            d="M20 38 L30 50 M40 38 L50 50 M60 38 L70 50 M80 38 L90 50"
            stroke="#ffffff"
            strokeWidth="4"
            strokeLinecap="round"
            className="opacity-90"
        />

        {/* Slate text grids */}
        <rect x="20" y="60" width="18" height="8" rx="2" fill="#f97316" fillOpacity="0.15" />
        <rect x="41" y="60" width="18" height="8" rx="2" fill="#f97316" fillOpacity="0.15" />
        <rect x="62" y="60" width="18" height="8" rx="2" fill="#f97316" fillOpacity="0.15" />

        <text x="29" y="66" fontSize="5" fontWeight="bold" textAnchor="middle" fill="#f97316">SCENE</text>
        <text x="50" y="66" fontSize="5" fontWeight="bold" textAnchor="middle" fill="#f97316">TAKE</text>
        <text x="71" y="66" fontSize="5" fontWeight="bold" textAnchor="middle" fill="#f97316">ROLL</text>

        <text x="29" y="77" fontSize="8" fontWeight="bold" textAnchor="middle" fill="#ffffff">404</text>
        <text x="50" y="77" fontSize="8" fontWeight="bold" textAnchor="middle" fill="#ffffff">1</text>
        <text x="71" y="77" fontSize="8" fontWeight="bold" textAnchor="middle" fill="#ffffff">LOST</text>

        {/* Clapperboard top (movable bar) */}
        <g className="clapper-top">
            {/* The top bar */}
            <path
                d="M10 26 H90 V38 H10 Z"
                fill="var(--clapper-top)"
                stroke="var(--clapper-border)"
                strokeWidth="1.5"
            />
            {/* White stripes on top bar */}
            <path
                d="M18 38 L28 26 M38 38 L48 26 M58 38 L68 26 M78 38 L88 26"
                stroke="#ffffff"
                strokeWidth="4"
                strokeLinecap="round"
            />
        </g>
        {/* Metallic rivet hinge dot at pivot point */}
        <circle
            cx="14"
            cy="38"
            r="2"
            fill="#94a3b8"
            stroke="#1e293b"
            strokeWidth="0.5"
        />
    </svg>
);

// ═══════════════════════════════════════════════════════════════════════
//  ICON MAP - For dynamic lookups (e.g., from config/constants)
// ═══════════════════════════════════════════════════════════════════════

export const IconMap = {
    // Solid
    gem: GemIcon,
    film: FilmIcon,
    server: ServerIcon,
    filter: FilterIcon,
    tv: TvIcon,
    language: LanguageIcon,
    video: VideoIcon,
    sliders: SlidersIcon,
    copy: CopyIcon,
    ellipsis: EllipsisIcon,
    'share-nodes': ShareNodesIcon,
    rocket: RocketIcon,
    wifi: WifiIcon,
    'triangle-exclamation': TriangleExclamationIcon,
    lightbulb: LightbulbIcon,
    desktop: DesktopIcon,
    cog: CogIcon,
    sun: SunIcon,
    moon: MoonIcon,
    'user-secret': UserSecretIcon,
    download: DownloadIcon,
    times: TimesIcon,
    envelope: EnvelopeIcon,
    'info-circle': InfoCircleIcon,
    'magnifying-glass': MagnifyingGlassIcon,
    'arrow-up': ArrowUpIcon,
    'chevron-up': ChevronUpIcon,
    'cloud-arrow-down': CloudArrowDownIcon,
    'wifi-slash': WifiSlashIcon,
    'rotate-right': RotateRightIcon,
    house: HouseIcon,
    'circle-exclamation': CircleExclamationIcon,
    'file-contract': FileContractIcon,
    comments: CommentsIcon,
    'comment-sms': CommentSmsIcon,
    clapperboard: ClapperboardIcon,
    'animated-clapperboard': AnimatedClapperboard,
    heart: HeartIcon,
    'arrow-right': ArrowRightIcon,
    plus: PlusIcon,
    check: CheckIcon,
    // Brands
    facebook: FacebookIcon,
    whatsapp: WhatsAppIcon,
    telegram: TelegramIcon,
    'x-twitter': XTwitterIcon,
    pinterest: PinterestIcon,
    threads: ThreadsIcon,
    linkedin: LinkedInIcon,
    messenger: MessengerIcon,
    reddit: RedditIcon,
    android: AndroidIcon,
    apple: AppleIcon,
    discord: DiscordIcon,
    snapchat: SnapchatIcon,
} as const;

export type IconName = keyof typeof IconMap;
